import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Plus, Minus } from 'lucide-react';
const FAQS = [{
  q: '¿Cómo lo recibo?',
  a: 'Al instante. Apenas pagás, te llega el acceso de descarga a tu correo.'
}, {
  q: '¿En qué formato está?',
  a: 'PDF. Lo abrís desde el celular, la compu o la tablet. Es tuyo para siempre.'
}, {
  q: '¿En cuánto tiempo veo resultados?',
  a: 'Con 5 minutos por día, la mayoría nota el cambio en la primera semana. El Protocolo está diseñado para 21 días.'
}, {
  q: '¿Necesito saber algo previo?',
  a: 'Nada. Está hecho para aplicarlo desde el día 1.'
}, {
  q: '¿Es teoría de autoayuda?',
  a: 'No. Es "descarga y aplica": cada sección tiene ejercicios para hacer.'
}, {
  q: '¿Funciona si soy muy negativo/a o ya probé de todo?',
  a: 'Sí. La diferencia es la repetición diaria + el protocolo de 21 días.'
}, {
  q: '¿Cuánto tiempo me lleva por día?',
  a: '5 minutos. Entra en cualquier rutina.'
}, {
  q: '¿Qué diferencia hay entre los dos planes?',
  a: 'El Esencial trae el Tomo 1 + los 6 bonos. La Transformación Completa suma los Tomos 2 y 3.'
}, {
  q: '¿Y si no es para mí?',
  a: 'Tenés 7 días de garantía. Si no te suma, te devolvemos el 100%.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-20 px-4 max-w-3xl mx-auto pt-[40px] pb-[40px]" data-id="element-51">
      <h2 className="font-serif text-3xl md:text-4xl text-brown font-bold text-center mb-12" data-id="element-52">
        Preguntas Frecuentes
      </h2>

      <div className="space-y-3" data-id="element-53">
        {FAQS.map((faq, i) => <div key={i} className="bg-white rounded-xl border border-gold/20 overflow-hidden" data-id="element-54">
            <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-6 py-4 flex items-center justify-between text-left hover:bg-cream/50 transition-colors" aria-expanded={openIndex === i} data-id="element-55">
              <span className="font-sans font-bold text-brown pr-4" data-id="element-56">
                {faq.q}
              </span>
              {openIndex === i ? <Minus className="w-5 h-5 text-gold shrink-0" data-id="element-57" /> : <Plus className="w-5 h-5 text-gold shrink-0" data-id="element-58" />}
            </button>

            <AnimatePresence initial={false} data-id="element-59">
              {openIndex === i && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.3
          }} data-id="element-60">
                  <div className="px-6 pb-4 pt-1" data-id="element-61">
                    <p className="font-sans text-brown/80 leading-relaxed text-sm" data-id="element-62">
                      {faq.a}
                    </p>
                  </div>
                </motion.div>}
            </AnimatePresence>
          </div>)}
      </div>
    </section>;
}